/* eslint-disable no-plusplus */
/* eslint-disable no-shadow */

export function cpf(value) {
  const cpf = value.replace(/[^\d]+/g, '')

  if (cpf.match(/(\d)(\1{10})/g)) {
    return false
  }

  let add = 0

  for (let i = 0; i < 9; i += 1) {
    add += parseInt(cpf.charAt(i), 10) * (10 - i)
  }

  let rev = 11 - (add % 11)

  if (rev === 10 || rev === 11) {
    rev = 0
  }

  if (rev !== parseInt(cpf.charAt(9), 10)) {
    return false
  }

  add = 0

  for (let i = 0; i < 10; i += 1) {
    add += parseInt(cpf.charAt(i), 10) * (11 - i)
  }

  rev = 11 - (add % 11)

  if (rev === 10 || rev === 11) {
    rev = 0
  }

  if (rev !== parseInt(cpf.charAt(10), 10)) {
    return false
  }

  return true
}

export function cnpj(value) {
  const cnpj = value.replace(/[^\d]+/g, '')

  if (cnpj.match(/(\d)(\1{13})/g)) {
    return false
  }

  let size = cnpj.length - 2
  let numbers = cnpj.substring(0, size)
  const digits = cnpj.substring(size)
  let sum = 0
  let pos = size - 7

  for (let i = size; i >= 1; i -= 1) {
    sum += numbers.charAt(size - i) * pos--

    if (pos < 2) {
      pos = 9
    }
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11)

  if (result !== parseInt(digits.charAt(0), 10)) {
    return false
  }

  size += 1
  numbers = cnpj.substring(0, size)
  sum = 0
  pos = size - 7

  for (let i = size; i >= 1; i -= 1) {
    sum += numbers.charAt(size - i) * pos--

    if (pos < 2) {
      pos = 9
    }
  }

  result = sum % 11 < 2 ? 0 : 11 - (sum % 11)

  if (result !== parseInt(digits.charAt(1), 10)) {
    return false
  }

  return true
}
